module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot1-3dbe07a97816b100ed9a30980f78cc39.png";